module.exports = __webpack_public_path__ + "static/img/16037B_2_R_20230105_fit.9b17aed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16037B_2_R_20230105_fit.png
// module id = MwnV
// module chunks = 0